import { useTranslation } from 'react-i18next';
import Sifra from '../../../../../../../../shared/components/Sifra';
import MantineGrid from '../../../../../../UI/MantineGrid/ManiteGrig';
import useHttp from '../../../../../../../hooks/use-http';
import { urls } from './api/urls';
import { useContext, useEffect } from 'react';
import { formatDateFromDB } from '../../../../../../../../utils/FormatDate';
import { TabContext } from '../../../../../../../Context/TabContext';

const RNGridProvider = ({ idMasine }) => {
  const { t, i18n } = useTranslation();
  const { addTab } = useContext(TabContext);
  const { sendRequest, data, getData } = useHttp('');

  useEffect(() => {
    sendRequest({
      method: 'POST',
      url: urls.GET_RADNI_NALOG_ZA_MASINU,
      data: { id: idMasine },
    });
  }, []);

  const handleOpenDetail = (item) => {
    // console.log(item);
    const tab = {
      title: 'Radni nalog',
      icon: 'fas fa-clipboard',
      type: 10012,
      data: item,
    };
    addTab(tab);
  };
  const handleClickDok = async (item) => {
    const tab = {
      title: 'Pregled zahteva',
      icon: 'fas fa-clipboard',
      type: 10014,
      data: { idDok: item.idDokServisnogZahteva },
    };
    addTab(tab);
  };
  const columns = [
    {
      field: 'ceoBrDok',
      headerName: 'Broj radnog naloga',
      renderCell: (e) => (
        <Sifra
          displayValue={e.renderedCellValue}
          onClick={() => handleOpenDetail(e.row.original)}
        />
      ),
      // size: 300,
    },
    {
      field: 'ceoBrDokServisnogZahteva',
      headerName: 'Broj zahteva',
      renderCell: (e) => (
        <Sifra
          displayValue={e.renderedCellValue}
          onClick={() => handleClickDok(e.row.original)}
        />
      ),
      // size: 200,
    },
    {
      field: 'datum',
      headerName: 'Datum',
      renderCell: (e) => {
        return formatDateFromDB(e.row.original.datum);
      },
      // size: 200,
    },
    {
      field: 'status',
      headerName: 'Status naloga',
      // size: 200,
    },
    {
      field: 'napomena',
      headerName: 'Napomena',
      size: 400,
    },
  ];

  return (
    <div
      style={{
        marginTop: '10px',
        height: 'fit-content',
        width: '99%',
      }}
    >
      <MantineGrid columns={columns} data={data} />
    </div>
  );
};

export default RNGridProvider;
